module.exports = __webpack_public_path__ + "static/media/share_screen.3cef638c.svg";